function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 463.862,
  height: 463.862
}, props), /*#__PURE__*/React.createElement("rect", {
  width: 463.862,
  height: 463.862,
  ry: 52.766,
  style: {
    opacity: 1,
    fill: "#7289da",
    fillOpacity: 1,
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeDashoffset: 0,
    strokeOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m296.087 80.93-11.506 3.308c-12.223-1.805-24.757-2.597-36.895-2.508-13.5.1-26.498 1.2-37.898 3.2-3.7.65-7.047 1.385-10.108 2.198h-35.892v18.801h4.5v7.7h2.783c-.64 3.714-.885 7.8-.885 12.3v4h-15.398l-2.201 11 17.6 15.014v.086h79.2v10h-108.9c-23 0-43.2 13.8-49.5 40-7.3 30-7.6 48.8 0 80.2a87 87 0 0 0 1.684 6.063l-1.184 10.438 13.346 11.549c7.032 7.51 16.37 11.951 28.254 11.951h27.2v-36c0-26 22.6-49 49.5-49h79.2c22 0 39.6-18.102 39.6-40.102V125.93c0-12.9-6.582-23.831-16.516-31.273zm76.8 77.599-14.3 7.4h-20.1v35.1c0 27.2-23.1 50-49.5 50h-79.1c-21.7 0-39.6 18.5-39.6 40.1v75.101c0 21.4 18.7 34 39.6 40.1 25.1 7.3 49.1 8.7 79.1 0 19.9-5.7 39.6-17.3 39.6-40.1v-30.102h-.12l-11.72-10h51.44c23 0 31.6-16 39.6-40 8.3-24.7 7.9-48.499 0-80.199-3.622-14.49-9.352-26.71-18.946-33.699zm-123.4 167.6h57.5v10h-57.5z",
  style: {
    display: "inline",
    fill: "#000",
    fillOpacity: 0.20554271
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M229.987 66.63c-13.5.1-26.5 1.2-37.9 3.2-33.5 5.9-39.6 18.2-39.6 41v30.1h79.2v10h-108.9c-23 0-43.2 13.8-49.5 40-7.3 30-7.6 48.8 0 80.2 5.6 23.4 19.1 40 42.1 40h27.2v-36c0-26 22.6-49 49.5-49h79.1c22 0 39.6-18.1 39.6-40.1v-75.2c0-21.4-18.1-37.4-39.6-41-13.5-2.3-27.6-3.3-41.2-3.2m-42.8 24.2c8.2 0 14.9 6.8 14.9 15.1s-6.7 15-14.9 15-14.9-6.7-14.9-15c0-8.4 6.7-15.1 14.9-15.1",
  style: {
    display: "inline",
    fill: "#cbd6ff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M320.787 150.93v35c0 27.2-23.1 50-49.5 50h-79.1c-21.7 0-39.6 18.5-39.6 40.1v75.1c0 21.4 18.7 34 39.6 40.1 25.1 7.3 49.1 8.7 79.1 0 19.9-5.7 39.6-17.3 39.6-40.1v-30.1h-79.1v-10h118.7c23 0 31.6-16 39.6-40 8.3-24.7 7.9-48.5 0-80.2-5.7-22.8-16.6-40-39.6-40h-29.7zm-44.5 190.2c8.2 0 14.9 6.7 14.9 15s-6.7 15.1-14.9 15.1-14.9-6.8-14.9-15.1 6.7-15 14.9-15",
  style: {
    display: "inline",
    fill: "#fff"
  }
}));
export default SvgLogo;